import React from 'react'
import ImageGallery from './components/ImageGallery'

function App() {
  return (
    <div className='App'><ImageGallery/></div>
  )
}

export default App